export const optionTitle_quickSteps = "_dD43d";
export const optionSearch_quickSteps = "QBFlE";
export default {optionTitle_quickSteps,optionSearch_quickSteps};